"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.8452 7.8437c.526 0 .9524-.4477.9524-1 0-.5522-.4264-1-.9524-1-.5259 0-.9523.4478-.9523 1 0 .5523.4264 1 .9523 1z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3v2h-1.9048v2l-6.3492 5h-2.0634c-.789 0-1.4286.6716-1.4286 1.5s.6396 1.5 1.4286 1.5h8.284c1.6261 0 2.513 2.1482 1.2061 3.282-3.1339 2.7188-6.7745 2.7184-10.4618 2.718C5.9883 20.9996 2 17.0207 2 12c0-4.8028 3.5829-8.727 8.0952-8.9863L22 3zM11.5238 16.9961 19.6457 17c-2.4926 1.9676-5.2371 2-8.9348 2-3.6819 0-6.8061-3.134-6.8061-7 0-3.6775 2.7008-6.6927 6.1334-6.978-.3703.7892-.511 1.6883-.478 2.5196.0367.9238.2917 1.9206.7802 2.7537-1.1725.5422-1.9911 1.7731-1.9911 3.2047 0 1.8771 1.4073 3.409 3.1745 3.4961zm-.0605-9.5377C11.4162 6.2698 11.8571 5.351 12.6477 5h5.5428v1l-5.0794 4h-.4257c-.645-.369-1.1746-1.346-1.2221-2.5416z"
  })];
};

exports.default = _default;